/* Arbove — Avis : barre de progression du carrousel (indicateur type scrollbar). */
(function () {
  if (window.__arReviews) return;
  window.__arReviews = true;

  function setup(sec) {
    var track = sec.querySelector('.rev-track');
    var fill = sec.querySelector('.rev-progress__fill');
    if (!track || !fill) return;

    var ticking = false;
    function update() {
      var frac = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      var max = track.scrollWidth - track.clientWidth;
      var prog = max > 0 ? track.scrollLeft / max : 0;
      if (frac > 1) frac = 1;
      fill.style.width = (frac * 100) + '%';
      fill.style.left = (prog * (1 - frac) * 100) + '%';
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var secs = document.querySelectorAll('[data-rev]');
    for (var i = 0; i < secs.length; i++) setup(secs[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
